module.exports = "https://cdn.realtymogul.com/static/media/mr2_img_annual_dist.ff10783e.png";